import deviceNames from '../data/device-names.json';

const canonicalNames = new Map<string, string>();
const searchNames = new Map<string, string>();

for (const [archiveName, fullName] of Object.entries(deviceNames)) {
  canonicalNames.set(archiveName.toLowerCase(), fullName);
  canonicalNames.set(fullName.toLowerCase(), fullName);
  searchNames.set(fullName, `${fullName} ${archiveName}`);
}

/** Resolve old device filters without changing archive paths or record IDs. */
export function normalizeDeviceName(device: string): string {
  return canonicalNames.get(device.trim().toLowerCase()) ?? device;
}

/** Keep familiar abbreviations searchable alongside the full console names. */
export function deviceSearchText(device: string): string {
  const fullName = normalizeDeviceName(device);
  return searchNames.get(fullName) ?? fullName;
}
